// Auth
export * from './auth/Login.interface'
export * from './auth/Recuperar.interface'
// Autoridad
export * from './autoridad/Autoridad.interface'
// Catalogo
export * from './catalogo/Catalogo.interface'
// Common
export * from './common/BaseFilter.model'
export * from './common/Common.interface'
export * from './common/Pagination.model'
export * from './common/Response.interface'
// Denominacion
export * from './denominacion/Denominacion.interface'
// email
export * from './email/Email.interface'
// Expediente
export * from './expediente/Expediente.interface'
// Pago
export * from './pago/Pago.interface'
// Preliminar
export * from './preliminar/Preliminar.interface'
// Recibo
export * from './recibo/Recibo.interface'
// Reporte
export * from './reporte/Reporte.interface'
// Requisito Tramite
export * from './requisito-tramite/RequisitoTramite.interface'
// Solicitud
export * from './solicitud/Solicitud.interface'
// Store
export * from './store/AuthState.interface'
export * from './store/AutoridadState.interface'
export * from './store/BandejaSolicitudState.interface'
export * from './store/CatalogoState.interface'
export * from './store/EmailState.interface'
export * from './store/ExpedienteState.interface'
export * from './store/PreliminarState.interface'
export * from './store/ReporteState.interface'
export * from './store/RequisitoTramiteState.interface'
export * from './store/UniversidadState.interface'
export * from './store/UsuarioState.interface'
// Universidad
export * from './universidad/Escuela.interface'
export * from './universidad/EspecialidadPrograma.interface'
export * from './universidad/Facultad.interface'
export * from './universidad/Universidad.interface'
// Usuario
export * from './usuario/Usuario.interface'
